/* eslint-disable max-depth */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable global-require */
// eslint-disable-next-line max-lines-per-function
import { captureMessage } from '@sentry/browser';
import api from 'Cloud/Application/api';
import config from 'Cloud/config';
import { logger } from 'lib/logger';
import { clone } from 'ramda';
import { itemV4ToV2 } from 'reactApp/api/helpers/apiV4Helpers';
import { PublicListAPICall } from 'reactApp/api/PublicListAPICall';
import { getFolderParams, isFolder } from 'reactApp/modules/file/utils';
import { updateFolder } from 'reactApp/modules/modifying/modifying.actions';
import { addFileHelper, addFolderHelper } from 'reactApp/modules/modifying/modifying.helpers';
import { EModifyReason } from 'reactApp/modules/modifying/modifying.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { store } from 'reactApp/store';

// eslint-disable-next-line max-lines-per-function
export default function (app, _) {
    const IS_PUBLIC = app.isPublic();
    const IS_REACT_PAGE = config.get('REACT_PAGE');

    Object.assign(app, {
        updateFile: patron.defer(function (d, file, storage) {
            var tree = _.tree(storage || 'home');
            tree.updateItem(file);
            tree.updateAuthors(tree.getParentId(file));

            d.resolve(file.id);
            app.emit('modifying:update', tree.get(file.id));

            app.user.updateSpace();
        }),

        updateFolder: patron.defer(async function (d, folder) {
            const tree = _.tree();
            const currentFolder = app.currentFolder();

            const setFolder = function (folder) {
                // dontSyncWithRedux - true. В setFolder элементы обновляют редакс по одному,
                // хотя все, что нужно, обновил updateFolder
                tree.setFolder(folder, void 0, true, undefined, true);

                d.resolve(folder.id);

                app.emit('modifying:update', tree.get(folder.id));

                app.user.updateSpace();
            };

            folder = tree.get(folder, false);

            if (folder.id === currentFolder?.id) {
                const params = getFolderParams(folder, IS_PUBLIC);

                if (params) {
                    params.sort = tree.getSort(folder);
                    params.offset = 0;
                    params.limit = folder.count.folders + folder.count.files;

                    const storage = getCurrentStorage(store.getState());

                    if (storage === EStorageType.public) {
                        try {
                            const newFolder = await new PublicListAPICall().makeRequest(params);
                            const result = itemV4ToV2(newFolder?.data, storage, true);

                            store.dispatch(updateFolder(clone(result)));

                            return setFolder(newFolder);
                        } catch (error) {
                            logger.error(error);
                            d.reject(error);
                        }
                    } else {
                        api.folder(params)
                            .done((newFolder) => {
                                store.dispatch(updateFolder(clone(newFolder)));

                                return setFolder(newFolder);
                            })
                            .fail(function (errors) {
                                d.reject(errors);
                            });
                    }
                } else {
                    setFolder(folder);
                }
            } else {
                setFolder(folder);
            }
        }),

        addFile: patron.defer(function (d, file, parent, skipXhr, storageName, conflictMode) {
            const storage = storageName || (app.isSearch() ? 'search' : 'home'); // CLOUDWEB-3359

            const success = (item) => {
                const tree = _.tree(storage);
                const res = tree.setItem(item, parent);
                if (res) {
                    res.increaseParentCount(item.id).sortParentItems(item.id);
                    tree.updateAuthors(parent);
                }

                const parentItem = tree.get(parent);
                if (parentItem && item.size && parentItem.size !== undefined) {
                    parentItem.size += +item.size;
                    app.emit('modifying:update', parentItem);
                }

                d.resolve(item.id);

                app.emit('modifying:add', tree.get(item.id));

                app.user.updateSpace();
            };

            const res = addFileHelper({
                item: file,
                parent,
                storage,
                skipXhr,
                conflictMode,
                reason: EModifyReason.add,
            });

            if (skipXhr) {
                success(res);
            } else {
                res.then(success).catch((error, status) => {
                    d.reject(error, status);
                });

                RADAR.deferred('app_add-file_' + _.sid(), d.promise());
            }
        }),

        addFolder: patron.defer(function (d, item, parent, skipXhr, conflictMode, storageName, reason) {
            const storage = storageName || (app.isSearch() ? 'search' : 'home'); // CLOUDWEB-3359

            const tree = _.tree(storage);
            const storageId = _.cid();
            parent = parent || tree.folder(storageId);

            if (!skipXhr) {
                RADAR.deferred(`app_add-folder_${storageId}`, d.promise());
            }

            const success = (item) => {
                tree.setFolder(item).increaseParentCount(item.id).sortParentItems(item.id);

                d.resolve(item.id);

                app.emit('modifying:add-folder', tree.get(item.id));

                app.user.updateSpace();
            };

            const res = addFolderHelper({
                item,
                parent,
                storage,
                skipXhr,
                conflictMode,
                reason,
            });

            if (skipXhr) {
                success(res);
            } else {
                res.then(success).catch((error) => {
                    captureMessage('ADD FOLDER', {
                        arguments: error,
                    });

                    d.reject((error.home && error.home.error) || error);
                });
            }
        }),

        addOldItems: (items, parent, storageName) => {
            if (IS_REACT_PAGE) {
                return;
            }

            const storage = storageName || (app.isSearch() ? 'search' : 'home'); // CLOUDWEB-3359
            const tree = _.tree(storage);
            const storageId = _.cid();
            parent = parent || tree.folder(storageId);

            items.forEach((item) => {
                if (isFolder(item)) {
                    tree.setFolder(item).increaseParentCount(item.id).sortParentItems(item.id);

                    app.emit('modifying:add-folder', tree.get(item.id));

                    return;
                }

                const res = tree.setItem(item, parent);

                if (res) {
                    res.increaseParentCount(item.id).sortParentItems(item.id);
                    tree.updateAuthors(parent);
                }

                const parentItem = tree.get(parent);

                if (parentItem && item.size && parentItem.size !== undefined) {
                    parentItem.size += +item.size;
                    app.emit('modifying:update', parentItem);
                }

                app.emit('modifying:add', tree.get(item.id));
            });
        },

        // Метод для удаления из старого дерева
        removeOldItems(ids) {
            if (IS_REACT_PAGE) {
                return;
            }

            _.tree(_.sid())
                .decreaseParentCount(app.isFavorites() ? null : ids)
                .remove(ids);
        },
    });
}
